export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/57a43ba76340ea303ae7dc89733370a0.svg";